import React from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import {
  setadminuseraccessceateActions,
  setadminuseraccessRetrieveActions,
  setadminuseraccessEDITActions,
} from "../../../Redux/Slice";
const AdminuserCreate = (props) => {
  const { show, setShow, EditId ,         Number ,    currentPage , 
    search
} = props;
  console.log(EditId, "EditId");
  const dispatch = useDispatch();
  const [disnaErr, setDiseRR] = useState("");
  const [UniqueNERR, setUniquErr] = useState("");
  const [DisplOrderErr, setDisErr] = useState("");
  const state = useSelector((state) => state);
  const handleClose = () => {
    setShow(false);
  };

  const [data, setdata] = useState({
    display_name: "",
    unique_name: "",
    display_order: Number,
  });

  //---admin---user-=====retrieve---
  useEffect(() => {
    if (EditId != undefined) {
      const payload = {
        EditID: EditId,
      };
      dispatch(setadminuseraccessRetrieveActions(payload));
    }
  }, []);
  console.log(
    state.adminuseraccessRETRIEVE.adminuseraccessREtrievedata.display_name,
    "adminuseraccessRETRIEVE"
  );
  useEffect(() => {
    if (
      EditId != undefined &&
      state.adminuseraccessRETRIEVE.adminuseraccessREtrievedata != undefined &&
      EditId == state.adminuseraccessRETRIEVE.adminuseraccessREtrievedata.id
    ) {
      setdata({
        ...data,
        display_name:
          state.adminuseraccessRETRIEVE.adminuseraccessREtrievedata
            .display_name,
        unique_name:
          state.adminuseraccessRETRIEVE.adminuseraccessREtrievedata.unique_name,
        display_order:
          state.adminuseraccessRETRIEVE.adminuseraccessREtrievedata
            .display_order,
      });
    }

    console.log(data, "sdfsdfwed");
  }, [state.adminuseraccessRETRIEVE.adminuseraccessREtrievedata]);
  const HandleChanges = (e) => {
    if (e.target.name == "display_order") {
      const { name, value } = e.target;

      setdata({
        ...data,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;

      setdata({
        ...data,
        [name]: value,
      });
    }
  };
  console.log(EditId, "EditId");
  const handleSubmit = (e) => {
    var a = 0;

    if (data.display_name == "") {
      a = 1;
      setDiseRR("*Display name is required");
    }

    if (data.unique_name == "") {
      a = 1;
      setUniquErr("*Unique name is required");
    }

    if (data.display_order == "") {
      a = 1;
      setDisErr("*Display order is required");
    }

    if (a == 0 && EditId == undefined) {
      console.log(data, "sdfbweo");
      const payload ={
        data:data , 
        currentPage:currentPage, 
        search:search
      }
      dispatch(setadminuseraccessceateActions(payload , setShow(false) ));
    } else if (a == 0 && EditId != undefined) {
      const payload = {
        data: data,
        EditId: EditId,
        currentPage:currentPage,
        search:search

      };
      dispatch(setadminuseraccessEDITActions(payload, setShow(false)));
    }
  };
  return (
    <>
      <Modal
        aria-labelledby="contained-modal-title-vcenter Filters"
        centered
        show={show}
        onHide={handleClose}
        className="modelman"
      >
        <Modal.Header className="popHead">
          <Modal.Title>
<h3>            { EditId == undefined
            ? " Admin User list"
            : " Admin User list "}
            </h3>
          </Modal.Title>
          <div className="CloseIcon" onClick={() => setShow(false)}>
            <CloseOutlinedIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group AdminAccessBody">
            <label htmlFor="grading_name" className="form-label">
              Display Name<span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="display_name"
              value={data.display_name}
              onChange={(e) => {
                HandleChanges(e);
                setDiseRR("");
              }}
            />
            <p className="Error" style={{ marginLeft: "-10px" }}>
              {disnaErr}
            </p>

            <label htmlFor="grading_name" className="form-label" style={{ marginTop: "12px" }}>
              Unique Name<span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="unique_name"
           disabled={EditId != undefined ? true : false}
              value={data.unique_name}
              onChange={(e) => {
                HandleChanges(e);
                setUniquErr("");
              }}
            />
            <p className="Error" style={{ marginLeft: "-10px" }}>
              {UniqueNERR}
            </p>

            <label htmlFor="grading_name" style={{ marginTop: "12px" }} className="form-label"> 
              Display Order<span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              className="form-control"
              name="display_order"
              value={data.display_order}
              onChange={(e) => {
                HandleChanges(e);
                setDisErr("");
              }}
              //  readOnly
              //  disabled
            />

            <p className="Error" style={{ marginLeft: "-10px" }}>
              {DisplOrderErr}
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="RoleButton Filters">
            <button class="btn  SaveBtn" type="submit" onClick={handleSubmit}>
              Submit
            </button>
            <button class="btn CancelBtn" onClick={handleClose}>
              Cancel
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminuserCreate;
